import { render, staticRenderFns } from "./ProgressItem.vue?vue&type=template&id=498864e5&"
import script from "./ProgressItem.vue?vue&type=script&lang=js&"
export * from "./ProgressItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports